<template>
  <div id="app">
    <component :is="themeComponent" />
  </div>
</template>

<script>
import { DOMAIN_GOOGLE_GTAG } from "./utils/constant";
import { getGaCode, getInviteCodeFile } from "./utils/request";
import Vue from "vue";
import CryptoJS from 'crypto-js';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { detectBrowser, setCookie } from "./utils/util";

export default {
  name: "App",
  data() {
    return {
      googleGtag: DOMAIN_GOOGLE_GTAG
    };
  },
  computed: {
    themeComponent: function() {
      const compMap = window.componentsConfig;
      const theme = process.env.theme;
      console.log(process.env.theme);
      return () => Promise.resolve(require(`${compMap[theme]}`));
    }
  },
  created() {
    Vue.prototype.inviteCodeObj = {};
    this.setDomainGoogleGtag();
    this.getInviteData();
    this.createTrustedToken();
  },
  methods: {
    async createTrustedToken() {
      const fp = await FingerprintJS.load();

      const fpData = await fp.get();

      const { visitorId } = fpData;

      // 密钥（必须为 16 / 24 / 32 字节）
      const key = CryptoJS.enc.Utf8.parse("WeYAhqcwbjbk4cy8");

      const screenResolution = `${window.screen.width}x${window.screen.height}`;

      const offsetHours = -new Date().getTimezoneOffset() / 60;

      // 明文
      const plaintext = JSON.stringify({
        visitorId: visitorId,
        userAgent: window.navigator.userAgent,
        screenResolution: screenResolution,
        timezone: offsetHours,
        platform: window.navigator.platform,
        language: window.navigator.language,
        browser: detectBrowser()
      });

      // 加密
      const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7 // 等同于 PKCS5
      });

      setCookie("trusted_token", encrypted.toString());
    },
    async setDomainGoogleGtag() {
      const host = location.host;
      if (Object.keys(this.googleGtag).indexOf(host) !== -1) {
        this.createGa(this.googleGtag[host]);
      } else {
        const json = {
          page: 1,
          size: 300,
          url: host
        };
        const res = await getGaCode(json);
        if (res.body.code == 200 || res.body.code == 0) {
          const data = res.body.data;
          const obj =
            data.pageBean.list.find(
              ({ url }) => window.location.origin.indexOf(url) > -1
            ) || {};
          this.createGa(obj.remark);
          Vue.prototype.inviteCode = "";
        }
      }
    },
    createGa(tagId) {
      if (tagId) {
        const st = document.createElement("script");
        st.async = true;
        st.src = `https://www.googletagmanager.com/gtag/js?id=${tagId}`;
        document.body.append(st);
        let innHtml = `window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());
                        gtag('config', '${tagId}');`;
        let st2 = document.createElement("script");
        st2.type = "text/javascript";
        st2.innerHTML = innHtml;
        document.body.append(st2);
      }
    },
    async getInviteData() {
      const data = await getInviteCodeFile();
      const { status, body } = data;
      if (status === 200) {
        Vue.prototype.inviteCodeObj = body;
      }
    }
  }
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
}
</style>



// WEBPACK FOOTER //
// src/App.vue